import React from "react";
import { List, CreateButton } from "@refinedev/mui";
import { DataGrid } from "@shared/components/DataGrid";

import { CsvExportButton, FilterDropdown } from "@shared/components";
import { CreateCategoryModal, EditCategoryModal, CategoryListFilters } from "@modules/categorys/components";

import {  useCategoryList } from "./controller";
import { useCategoryListColumns } from "./columns";

export const CategoryList = React.memo(() => {
  const {
    rows,
    loading,
    selectedRows,
    dataToExport,
    createCategoryModalRef,
    editCategoryModalRef,
    setSelectedRows,
    refetch,
    translate,
    tableProps
  } =  useCategoryList();

  const columns = useCategoryListColumns(refetch, translate, editCategoryModalRef);

  return (
    <List
      headerButtons={
        <>
          <FilterDropdown
            initialValues={{
              search: "",
            }}
          >
            <CategoryListFilters />
          </FilterDropdown>

          <CsvExportButton
            data={dataToExport}
            filename="agreements.csv"
            isDisabled={loading || !rows}
          />

          <CreateButton onClick={() => createCategoryModalRef.current?.open()} />
        </>
      }
    >
      <DataGrid
        {...tableProps}
        rows={rows}
        columns={columns}
        loading={loading}
        checkboxSelection
        rowSelectionModel={selectedRows}
        onRowSelectionModelChange={(selectionModel) =>
          setSelectedRows(selectionModel as number[])
        }
      />

      <CreateCategoryModal
        modalRef={createCategoryModalRef}
        onComplete={() => {
          refetch();
          setSelectedRows([]);
        }}
      />
      
      <EditCategoryModal
        modalRef={editCategoryModalRef}
        onComplete={() => {
          refetch();
          setSelectedRows([]);
        }}
      />
    </List>
  );
});
